const MONTH_ONLY = /^[A-Za-z]{3}$/;
const MONTH_YEAR = /^[A-Za-z]{3}\s+\d{4}$/;
const DAY_ONLY = /^\d{1,2}$/;

export function lineChartRightGutter(label: string): number {
    const trimmed = label.trim();

    if (MONTH_ONLY.test(trimmed)) {
        return 16;
    }

    if (MONTH_YEAR.test(trimmed)) {
        return 36;
    }

    if (DAY_ONLY.test(trimmed)) {
        return 10;
    }

    return Math.min(40, Math.max(16, Math.round(trimmed.length * 3.5) + 6));
}
